import { render, staticRenderFns } from "./UserMarketingPage.vue?vue&type=template&id=174c03e1&scoped=true"
import script from "./UserMarketingPage.vue?vue&type=script&lang=js"
export * from "./UserMarketingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174c03e1",
  null
  
)

export default component.exports